import * as React from 'react';
import { action } from 'mobx';
import { PageComponent } from '../../../../utils';
import {
  PageProps,
  PageToolEvents,
} from '../../../../constants';
import { GridLayout } from '../../../../components';
import { InfinityRetrieve } from '../../../../models';
import { Today } from '../../../../utils/time';
import { MonthEmergencyCallTemplate } from './MonthEmergencyCall.template';
import { MonthEmergencyCallRecentModel } from './MonthEmergencyCallRecent.model';
import { MonthEmergencyCallDetailModel } from './MonthEmergencyCallDetail.model';
import { ConfirmWarning } from '../../../../utils/confirm';

interface MonthEmergencyCallState {
  // 조회조건
  yearMon: string;
  searchQuery: string;
  divicd: string;
  divinm: string;
  perid: string;
  pernm: string;
  telcomp: string;
  susin: string;
  result: string;

  // 왼쪽 최근내역 리스트
  recentList: Array<MonthEmergencyCallRecentModel>;

  // 오른쪽 상세내역 List
  detailList: Array<MonthEmergencyCallDetailModel>;
}

/**
 * 컨트롤러
 * @window w_tb_e035w_05
 * @category 월점검 비통채크현황
 */
export class MonthEmergencyCall extends PageComponent<PageProps, MonthEmergencyCallState> implements PageToolEvents {
  grid: React.RefObject<GridLayout> = React.createRef();

  grid2: React.RefObject<GridLayout> = React.createRef();

  infinity?: InfinityRetrieve;

  constructor(props: PageProps, context: any) {
    super(props, context);
    this.props.onMount && this.props.onMount(this);

    this.state = {
      yearMon: Today.yearMon(),
      searchQuery: '',
      divicd: '',
      divinm: '',
      perid: '',
      pernm: '',
      telcomp: '%',
      susin: '%',
      result: '%',

      recentList: [],

      detailList: [],
    };
  }

  @action
  onFirstOpenEvent() {
    this.onRetrieveEvent();
  }

  @action
  async onRetrieveEvent() {
    const { actionStore: api } = this.props;

    this.infinity = new InfinityRetrieve(
      {
        mon: this.state.yearMon,
        perid: this.state.perid,
        divicd: this.state.divicd,
        as_nm: this.state.searchQuery,
        telcomp: this.state.telcomp,
        susin: this.state.susin,
        result: this.state.result,
      },
      (params) => (api.retrieve(params)),
      (items, next) => {
        this.setState({
          recentList: [...this.state.recentList || [], ...items.map((x: any) => new MonthEmergencyCallRecentModel(x))],
        }, next);
      },
      async () => {
        await this.SS({
          recentList: [],
        });
        await this.infinity?.retrieveAll();
        this.grid.current?.setFocus(0);
      },
    );

    // data 초기화
    await this.SS({
      recentList: [],
      detailList: [],
    });

    // 조회 data
    await this.infinity?.retrieveAll();

    if (this.state.recentList.length) {
      this.grid.current?.setFocus(0);
    }
  }

  @action
  async onRowFocusEvent(x: MonthEmergencyCallRecentModel) {
    const { actionStore: api } = this.props;

    await this.SS({
      detailList: [],
    });

    const data = await api.fxExec('dw_1_RowFocuschanged', {
      mon: this.state.yearMon,
      actcd: x.actcd,
      tel: x.tel,
    });

    if (data) {
      await this.SS({
        detailList: [...this.state.detailList, ...data.items?.map((x: any) => new MonthEmergencyCallDetailModel(x))],
      });
    }
  }

  @action
  async recordFileBtn() {
    ConfirmWarning.show('확인', 'WEB버전은 현재 준비중입니다...');
  }

  render() {
    return (
      <MonthEmergencyCallTemplate scope={this}></MonthEmergencyCallTemplate>
    );
  }
}
